export const Contactus = (props) => {
  return (
    <div id="contactus">
      <div className="contactus">
        <div className="container">
          <div className="section-title">
            <h2>{props.data ? props.data.title : "Loading"}</h2>
          </div>
          <div className="row">
            <p>{props.data ? props.data.paragraph : "Loading"}</p>
            <a href="#contact" className="btn btn-custom btn-lg page-scroll">
              Contact us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
